// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__XZwyt","bottomMargin":"Summary_bottomMargin__cnu_X"};